import { render, staticRenderFns } from "./ExistingArticlesOverview.vue?vue&type=template&id=276333be&scoped=true"
import script from "./ExistingArticlesOverview.vue?vue&type=script&lang=js"
export * from "./ExistingArticlesOverview.vue?vue&type=script&lang=js"
import style0 from "./ExistingArticlesOverview.vue?vue&type=style&index=0&id=276333be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276333be",
  null
  
)

export default component.exports